import Vue from 'vue';
import Vuex from 'vuex';

import pathify from './pathify';
import { make } from 'vuex-pathify';

import { clone, cloneDeep, each, mapValues, range, reverse } from 'lodash';

import section1 from '@/components/pages/1/section1';
import section2 from '@/components/pages/2/section2';
import section3 from '@/components/pages/3/section3';
import section4 from '@/components/pages/4/section4';
import section5 from '@/components/pages/5/section5';
import section6 from '@/components/pages/6/section6';
import section7 from '@/components/pages/7/section7';
import section8 from '@/components/pages/8/section8';
import section9 from '@/components/pages/9/section9';
import section10 from '@/components/pages/10/section10';
import section11 from '@/components/pages/11/section11';
import section12 from '@/components/pages/12/section12';
import section13 from '@/components/pages/13/section13';
import section14 from '@/components/pages/14/section14';
import section15 from '@/components/pages/15/section15';
import section16 from '@/components/pages/16/section16';
import section17 from '@/components/pages/17/section17';
import section18 from '@/components/pages/18/section18';
import section19 from '@/components/pages/19/section19';
import section20 from '@/components/pages/20/section20';

const modules = {
    section1,
    section2,
    section3,
    section4,
    section5,
    section6,
    section7,
    section8,
    section9,
    section10,
    section11,
    section12,
    section13,
    section14,
    section15,
    section16,
    section17,
    section18,
    section19,
    section20
};

// store copy of default (base) state for each module
const defaultStates = mapValues(modules, module => {
    return cloneDeep(module.state);
});
// add a 'resetState' mutation to each module, which will reset it back to its default (base) state
each(modules, (module, key) => {
    module.mutations.resetState = state => {
        Object.assign(state, defaultStates[key]);
    };
});
// add a 'repeatModule' mutation to each module, which will reset it back to its default (base) state, but keep it completed with stickers/trophies earned
each(modules, (module, key) => {
    module.mutations.repeatModule = state => {
        // remember if bonusSticker was earned
        let earnedBonus = false;
        if (state.bonusSticker && state.bonusSticker.earned) {
            earnedBonus = true;
        }

        // reset module state
        Object.assign(state, defaultStates[key]);

        // restore completion, stickers, trophies
        state.complete = true;
        state.sticker.earned = true;
        if (state.bonusSticker && earnedBonus) {
            state.bonusSticker.earned = true;
        }
        if (state.trophy) {
            state.trophy.earned = true;
        }
    };
});

Vue.use(Vuex);

const sectionOrder = range(20, 0);

const state = {
    user: null,
    photo: '',
    preferences: {
        name: '',
        pronoun: '',
        noPronoun: false,
        phone: '',
        email: ''
    },
    sectionOrder,
    visitedPages: {},
    audioEnabled: false,
    firstTime: true,
    finished: false
};
const getters = {
    ...make.getters(state),
    firstIncompleteSection: state => {
        let _section = null;
        each(reverse(clone(state.sectionOrder)), section => {
            if (!state[`section${section}`].complete) {
                _section = parseInt(section);
                return false;
            }
        });
        return _section;
    },
    hasVisited: state => page => {
        return state.visitedPages[`${page.section}/${page.page}`];
    }
};
const mutations = {
    ...make.mutations(state),
    loadState(state, savedState) {
        Object.assign(state, savedState);
    },
    visitPage(state, page) {
        state.visitedPages[`${page.section}/${page.page}`] = true;
    },
    unvisitSection(state, section) {
        let pages = Object.keys(state.visitedPages).filter(el => el.includes(`${section}/`));
        pages.forEach(p => delete state.visitedPages[p]);
    }
};
const actions = make.actions(state);

export default new Vuex.Store({
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    modules,
    plugins: [pathify.plugin]
});
